import React from 'react';
import "./date-element.css"
const DateElement = ({date}) => {
    return <div className="date-element text-teko">
        <p>{ new Date(date).toLocaleDateString('en-GB')}</p>
    </div>
}
export default DateElement;